import { computed, toValue, type ComputedRef, type MaybeRefOrGetter } from 'vue'

import { useCoursesAdminPreview } from './useCoursesAdminPreview'

function tryUseCoursesAdminPreview() {
  try {
    return useCoursesAdminPreview()
  } catch {
    return null
  }
}

/**
 * Location id for learner-only queries (library, /resolve, modules, progress, unlocks, activity).
 * Empty while a courses admin preview is active, so those queries self-disable on their
 * `!!locationId` guard instead of firing learner endpoints with the admin credential. Gating here,
 * inside the learner composables, keeps every caller covered without passing per-call flags.
 */
export const useLearnerScopedLocationId = (locationId: MaybeRefOrGetter<string | null | undefined>): ComputedRef<string> => {
  const adminPreview = tryUseCoursesAdminPreview()
  return computed(() => (adminPreview?.isActive?.value ? '' : toValue(locationId) || ''))
}

/** Whether a courses admin preview is active (learner writes must no-op). */
export const useIsCoursesAdminPreview = (): ComputedRef<boolean> => {
  const adminPreview = tryUseCoursesAdminPreview()
  return computed(() => !!adminPreview?.isActive?.value)
}
